var map = {
	"./Amla": [
		"e74d",
		"chunk-2d225f98"
	],
	"./Amla.vue": [
		"e74d",
		"chunk-2d225f98"
	],
	"./ConsumerProtection": [
		"19e3",
		"chunk-2d0ac98c"
	],
	"./ConsumerProtection.vue": [
		"19e3",
		"chunk-2d0ac98c"
	],
	"./Erm": [
		"86ef",
		"chunk-2d0ded15"
	],
	"./Erm.vue": [
		"86ef",
		"chunk-2d0ded15"
	],
	"./PrivacyPolicy": [
		"39f1",
		"chunk-2d0bb267"
	],
	"./PrivacyPolicy.vue": [
		"39f1",
		"chunk-2d0bb267"
	],
	"./Promo": [
		"f324",
		"chunk-3408d367"
	],
	"./Promo.vue": [
		"f324",
		"chunk-3408d367"
	],
	"./TermsAndConditions": [
		"c006",
		"chunk-2d215be9"
	],
	"./TermsAndConditions.vue": [
		"c006",
		"chunk-2d215be9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ad06";
module.exports = webpackAsyncContext;